module.exports = __webpack_public_path__ + "img/selected0-min.e50510d6.png";